import React, { useState } from "react";

export default function Tooltip({ text }: { text: string }) {
  const [visible, setVisible] = useState(false);

  return (
    <span
      style={{
        position: "relative",
        display: "inline-flex",
        alignItems: "center"
      }}
      onMouseEnter={() => setVisible(true)}
      onMouseLeave={() => setVisible(false)}
    >
      <span
        style={{
          width: 16,
          height: 16,
          borderRadius: "50%",
          background: "#e5e7eb",
          color: "#374151",
          fontSize: 11,
          fontWeight: 600,
          display: "flex",
          alignItems: "center",
          justifyContent: "center"
        }}
      >
        i
      </span>

      {visible && (
        <div
  style={{
    position: "absolute",
    top: 26,
    left: 0,
    background: "#111827", // slightly softer than pure navy
    color: "#e5e7eb",      // softer white
    padding: "8px 10px",
    borderRadius: 6,
    fontSize: 12,
    fontWeight: 400,
    lineHeight: 1.4,
    width: 200,
    boxShadow: "0 6px 16px rgba(0,0,0,0.12)",
    zIndex: 999,
    opacity: visible ? 1 : 0,
transition: "opacity 0.15s ease",
textTransform: "none"
  }}
>
  {text}
</div>
      )}
    </span>
  );
}